//ilanlar.ts

import { defineStore } from "pinia";
import { deepEqual } from '~/utils/deepEqual';

import {
  type GetAdvertisementAllRequest,
  GetAdvertisementAllResponse,
  GetAdvertisementByIdRequest,
} from "~/models/AdvertisementModels";
import { AdvantageousPurchaseRequest, AdvantageousPurchaseResponse, GetFeatureAdvertisementRequest, type FeatureAdvertisementResponse } from "~/models/FeatureAdvertisementModels";
import { AdvertisementService } from '~/services/AdvertisementService';
import {  PreSaleAdvantageService } from "~/services/PreSaleAdvantage";
export const useMyIlanlarStore = defineStore({
  id: 'myIlanlarStore',
  state: () => ({
    showMap: false,
    advertisementType: null as any,
    isLoadingClearAll: false,
    isLoadingSearch: false,
    allAdvertisementTypes: [
      { value: 1, text: "Satışta" },
      { value: 2, text: "Satış Bitti" },
      { value: 3, text: "Kiralandı" },
    ],
    isLoading: true,
    totalCount: 0,
    totalPages: 0,
    advertisementList: [] as GetAdvertisementAllResponse[],
    ramsList: [] as GetAdvertisementAllResponse[],
    preSaleAdvantageList: [] as GetAdvertisementAllResponse[],
    advertisementFilter: {
      pageNumber: 1,
      pageSize: 10,
      search: null,
      provinceId: null,
      districtId: null,
      minRentalIncome: null,
      minPrice: null,
      maxPrice: null,
      orderType: null,
      productDeveloperId: null,
      rateOfPieceFilter: null,
    } as GetAdvertisementAllRequest,
  
    IncomingFilter: {
      pageNumber: 1,
      pageSize: 10,
      search: null,
      provinceId: null,
      districtId: null,
      orderType: null,
      productDeveloperId: null,
    } as GetFeatureAdvertisementRequest,
    regionName: null as any,
    IncomingList: [] as FeatureAdvertisementResponse[],
    advantageousPurchaseList: [] as AdvantageousPurchaseResponse[],
    advantageousPurchaseFilter: {
      pageNumber: 1,
      pageSize: 10,
    } as AdvantageousPurchaseRequest,
    currentTab: 'advantageous' as string,
    advertisementDetail: null as any,
    isRamsPage: false as boolean,
  }),
  getters: {
    getTotalCount(state) {
      return state.totalCount;
    },
    getTotalPage(state){
      return state.totalPages
    },
    // getRegionId(state) {
    //   return state.regionId;
    // },
    getRegionName(state) {
      return state.regionName;
    },
    getAdvertisementFilter(state) {
      return state.advertisementFilter;
    },
    getIncomingFilter(state) {
      return state.IncomingFilter;
    },
    getAdvantageousPurchaseFilter(state) {
      return state.advantageousPurchaseFilter;
    },
    getCurrentTab(state){
      return state.currentTab
    },
    getIsRamsPage(state){
      return state.isRamsPage
    },
    getAdvertisementType(state){
      return state.advertisementType
    }
  },
  actions: {
    clearFilters() {
      this.advertisementFilter = {
        pageNumber: 1,
        pageSize: 12,
      } as GetAdvertisementAllRequest;
      this.IncomingFilter = {
        pageNumber: 1,
        pageSize: 12,
      } as GetFeatureAdvertisementRequest;
      this.advantageousPurchaseFilter = {
        pageNumber: 1,
        pageSize: 12,
      } as AdvantageousPurchaseRequest;
    },
    setAdvertisementType(value: number) {
      this.advertisementType = value;
      const router = useRouter();
      if (value === 1) {
        router.push("/yatirimlar");
      } else if (value === 2) {
        router.push("/yatirimlar/satis-bitti");
      } else if (value === 3) {
        router.push("/yatirimlar/kiralandi");
      }else if(value === 4){
        router.push("/firsatlar");
      }else if(value === 5){
        router.push("/firsatlar/gelecek-projeler");
      }
    },

    updateShowMap(newValue: boolean) {
      this.showMap = newValue;
    },
    // setRegionId(newValue: any) {
    //   sessionStorage.setItem('regionId', newValue);
    //   this.updateRegionId(parseInt(newValue));
    // },
    setRegionName(newValue: any) {
      sessionStorage.setItem('regionName', newValue);
      this.regionName = newValue
    },

    async getAdvertisementList() {
      const router = useRouter();
      const route = useRoute();
      const advertisementService = new AdvertisementService();
      this.isLoading = true;
      this.advertisementList = [];
    
      const serviceMap = {
        1: advertisementService.GetAdvertisementList,
        2: advertisementService.GetAdvertisementSoldedList,
        3: advertisementService.GetAdvertisementRentedList,
      };
    
      const serviceMethod = serviceMap[this.advertisementType as keyof typeof serviceMap];
    
      if (!serviceMethod) {
        this.isLoading = false;
        return;
      }
    
      const currentQuery = this.createQueryObject(this.advertisementFilter);
    
      serviceMethod.call(advertisementService, this.advertisementFilter)
        .then((res: any) => {
          if (res.data.isSuccess) {
            this.advertisementList = res.data.data;
            this.totalCount = res.data.count;
            this.totalPages = res.data.page;
    
            const routeQuery = Object.entries(route.query).reduce((acc: Record<string, string | string[]>, [key, value]) => {
              if (Array.isArray(value)) {
                acc[key] = value.map(String);
              } else {
                acc[key] = String(value);
              }
              return acc;
            }, {});
    
            // stringify kıyas: sadece route.query ile filtre arasında fark varsa push yap
            if (process.client && JSON.stringify(currentQuery) !== JSON.stringify(routeQuery)) {
              router.push({
                path: route.path,
                query: currentQuery,
              });
            }
    
            return res;
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err: any) => {
          if (err.response) {
            toast.error(err.response.data.message);
          } else {
            toast.error(err.message);
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingClearAll = false;
          this.isLoadingSearch = false;
        });
    },    
    async getPreSaleAdvantageList() {
      const router = useRouter();
      const route = useRoute();
      const preSaleAdvantageListServices = new PreSaleAdvantageService();
      this.isLoading = true;
      this.preSaleAdvantageList = [];


      preSaleAdvantageListServices.List(this.advertisementFilter)
        .then((res: any) => {
          if (res.data.isSuccess) {
            this.preSaleAdvantageList = res.data.data;
            this.totalCount = res.data.count;
            this.totalPages = res.data.page
            if (process.client && JSON.stringify(route.query) !== JSON.stringify(this.advertisementFilter)) {
              // Sadece query değişmişse `router.push` çalıştır
              const queryObject = this.createQueryObject(this.advertisementFilter);
              this.totalCount = res.data.count;
            }
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err: any) => {
          if (err && err.response) {
            toast.error(err.response.data.message);
          } else {
            toast.error(err ? err.message : 'Bir hata oluştu');
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingClearAll = false;
          this.isLoadingSearch = false;
        });
    },
    async getRamsList() {
      const router = useRouter();
      const route = useRoute();
      const advertisementService = new AdvertisementService();
      this.isLoading = true;
      this.ramsList = [];
      this.advertisementFilter.productDeveloperId=6;
      advertisementService.GetAdvertisementList(this.advertisementFilter)
        .then((res: any) => {
          if (res.data.isSuccess) {
            this.ramsList = res.data.data;
            this.totalCount = res.data.count;
            this.totalPages = res.data.page
            this.updateCurrentRamsPage(true);
            if (process.client && JSON.stringify(route.query) !== JSON.stringify(this.advertisementFilter)) {
              // Sadece query değişmişse `router.push` çalıştır
              const queryObject = this.createQueryObject(this.advertisementFilter);
              this.totalCount = res.data.count;
              router.push({
                path: route.path,
                query: queryObject,
              });
            }
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err: any) => {
          if (err.response) {
            toast.error(err.response.data.message);
          } else {
            toast.error(err.message);
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingClearAll = false;
          this.isLoadingSearch = false;
        });
    },
    async getFutureAdvantageList() {
      const router = useRouter();
      const route = useRoute();
      const advertisementService = new AdvertisementService();
      this.isLoading = true;
      this.preSaleAdvantageList = [];

      advertisementService.IncomingProjectGridList(this.advertisementFilter)
        .then((res: any) => {
          if (res.data.isSuccess) {
            this.preSaleAdvantageList = res.data.data;
            this.totalCount = res.data.count;
            this.totalPages = res.data.page
            if (process.client && JSON.stringify(route.query) !== JSON.stringify(this.advertisementFilter)) {
              // Sadece query değişmişse `router.push` çalıştır
              const queryObject = this.createQueryObject(this.advertisementFilter);
              this.totalCount = res.data.count;
              router.push({
                path: route.path,
                query: queryObject,
              });
            }
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err: any) => {
          if (err.response) {
            toast.error(err.response.data.message);
          } else {
            toast.error(err.message);
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingClearAll = false;
          this.isLoadingSearch = false;
        });
    },
    createQueryObject(filter: GetAdvertisementAllRequest | GetFeatureAdvertisementRequest): Record<string, string | string[]> {
      return Object.entries(filter).reduce((acc: Record<string, string | string[]>, [key, value]) => {
        if (
          key !== 'pageSize' &&
          key !== 'pageNumber' &&
          !(this.isRamsPage && key === 'productDeveloperId') &&
          value !== null &&
          value !== undefined &&
          value !== '' &&
          !(Array.isArray(value) && value.length === 0)
        ) {
          if (Array.isArray(value)) {
            acc[key] = value.map(String);
          } else {
            acc[key] = String(value);
          }
        }
        return acc;
      }, {});
    },
    setAdvertisementFilter(
      filter: GetAdvertisementAllRequest | GetFeatureAdvertisementRequest | AdvantageousPurchaseRequest,
      loading = false,
      fromBreadcrumb = false
    ) {
      if (!filter || typeof filter !== "object") return;
    
      const router = useRouter();
      const route = useRoute();
    
      const isRegionBased = "regionId" in filter;
      const currentFilter = isRegionBased ? this.IncomingFilter : this.advertisementFilter;
    
      const updatedFilter = {
        ...currentFilter,
        ...filter,
      };
    
      // 🔍 Farklı değilse hiçbir işlem yapma
      if (deepEqual(currentFilter, updatedFilter)) {
        return;
      }
    
      if (isRegionBased) {
        this.IncomingFilter = updatedFilter as GetFeatureAdvertisementRequest;
      } else {
        this.advertisementFilter = updatedFilter as GetAdvertisementAllRequest;
      }
    
      const queryObject = this.createQueryObject(updatedFilter);
      const isQueryEmpty = Object.keys(queryObject).length === 0;
      const shouldClearQuery = isQueryEmpty && !fromBreadcrumb;
    
      if (process.client) {
        sessionStorage.setItem("advertisementFilter", JSON.stringify(updatedFilter));
    
        router.push({
          path: route.path,
          query: shouldClearQuery ? {} : queryObject,
        });
    
        if (loading) {
          this.isLoadingSearch = true;
        } else {
          this.isLoadingClearAll = true;
        }
      }
    
      // ✅ API çağrısı yap
      if (!isRegionBased) {
        this.getAdvertisementList();
      }
    },      
    setAdvertisementFilterFromBreadcrumb(query: Record<string, any>) {
      const parsed: GetAdvertisementAllRequest = {
        pageNumber: Number(query.pageNumber) || 1,
        pageSize: Number(query.pageSize) || 12,
        provinceId: query.provinceId ? Number(query.provinceId) : null,
        districtId: query.districtId ? Number(query.districtId) : null,
        minPrice: query.minPrice ? Number(query.minPrice) : null,
        maxPrice: query.maxPrice ? Number(query.maxPrice) : null,
        minRentalIncome: query.minRentalIncome ? Number(query.minRentalIncome) : null,
        orderType: query.orderType ? Number(query.orderType) : null,
        rateOfPieceFilter: query.rateOfPieceFilter || null,
        productDeveloperId: query.productDeveloperId ? Number(query.productDeveloperId) : null,
      };
    
      this.setAdvertisementFilter(parsed, false, true); // 3. parametre breadcrumb flag’i
    },
    
    setCurrentPage(page: number) {
      this.advertisementFilter.pageNumber = page;
      this.setAdvertisementFilter(this.advertisementFilter, true);
    },  
    
    async getIncomingList() {
      const router = useRouter();
      const route = useRoute();
      const advertisementService = new AdvertisementService();
      this.isLoading = true;
      this.IncomingList = [];
      advertisementService.GetAdvertisementIncomingProjectList(this.IncomingFilter)
        .then((res: any) => {
          if (res.data.isSuccess) {
            this.IncomingList =
              res.data.data.length > 0 ? res.data.data[0].futureProjects : [];
            if (process.client && JSON.stringify(route.query) !== JSON.stringify(this.IncomingFilter)) {
              // Sadece query değişmişse `router.push` çalıştır
              const queryObject = this.createQueryObject(this.IncomingFilter);

              router.push({
                path: route.path,
                query: queryObject,
              });
            }
          } else {
            this.IncomingList = res.data.data
            //toast.error(res.data.message);
          }
        })
        .catch((err: any) => {
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingClearAll = false;
          this.isLoadingSearch = false;
        });
    },
    async getAdvantageousPurchaseList(body: AdvantageousPurchaseRequest) {
      const router = useRouter();
      const route = useRoute();
      const advertisementService = new AdvertisementService();
      this.isLoading = true;
      this.advantageousPurchaseList = [];
      advertisementService.GetAdvertisementAdvantageousPurchaseList(body)
        .then((res: any) => {
          if (res.data.isSuccess) {
            this.advantageousPurchaseList = res.data.data;
          }
        })
        .catch((err: any) => {
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingClearAll = false;
          this.isLoadingSearch = false;
        });
    },
    async getAdvertisementDetail(body: GetAdvertisementByIdRequest) {
      try {
        const preSaleAdvantageService = new PreSaleAdvantageService();
        const advertisementService = new AdvertisementService();
        const response = this.currentTab === 'advantageous' 
          ? await preSaleAdvantageService.Detail(body)
          : this.currentTab === 'yatirimlar' ? await advertisementService.GetAdvertisementById(body) 
          : await advertisementService.GetIncomingProjectById(body);
          if(this.currentTab === 'yatirimlar'){
            console.log(response, "yatırımlar")
          }
        if (response.data.isSuccess) {
          this.advertisementDetail = response.data.data;
        }
        return response;
      } catch (error) {
        console.error('GetAdvertisementDetail error:', error);
        throw error;
      }
    },
    setCurrentTab(tab: string) {
      this.currentTab = tab;
    },
    updateCurrentRamsPage(isRamsPage: boolean) {
      this.isRamsPage = isRamsPage;
    }
  },

  // hydrate(state) {
  //   // @ts-expect-error: https://github.com/microsoft/TypeScript/issues/43826
  //   state.regionId = useStorage('requestTypeId', 0);
  // },
});
